import "./landing-page-desc-block.component.scss"

export default {
  template: require('./landing-page-desc-block.component.html'),
  bindings: {
    color: "@dotColor",
    needHide: "@hideBodyIsSmallContent",
    theme: "@lpTheme"
  },
  transclude: {
    title: "?lpDescBlockTitle",
    body: "?lpDescBlockBody",
    action: "?lpDescBlockAction"
  },
  controller: function () {

    'ngInject';

    const self = this;

    self.$onInit = () => {
      self.dotColor = 'landing-page-desc-block__dot-' + self.color;
      self.bodyClass = self.needHide === 'true' ? 'hidden-sm hidden-xs' : '';
      self.themeClass = self.theme === 'dark' ? 'landing-page-desc-block__theme-dark' : 'landing-page-desc-block__theme-light';
    };
  }
};
